import withNavigate from "../../../routes/withNavigate.jsx";
import InsuranceContainer from "./InsuranceContainer.jsx";
import InsuranceStore from "./InsuranceStore.js";

export default InsuranceStore(withNavigate(InsuranceContainer));
